import React, { FunctionComponent } from 'react';
import HotTopicContainer from './hotTopicContainer';
import HotTopicSection from './topicsection';

export interface ITopicProps {
  className?: string;
  settings: any;
  components: { [key: string]: FunctionComponent<any> };
}

const HotTopicDetail: React.FunctionComponent<ITopicProps> = ({
  className,
  settings,
  components,
}) => (
  <HotTopicContainer className={className || ''}>
    <div className="topic-item">
      <HotTopicSection settings={settings} components={components} />
    </div>
  </HotTopicContainer>
);

export default HotTopicDetail;
